<template>
    <v-checkbox
            :label="label"
            v-model="chk"
            :indeterminate="indeterminate"
            @change="chk_change"
    ></v-checkbox>
</template>
<script>
    export default {
        name: 'Checkbox3',
        props: ['label', 'value'],
        data: () => ({
            chk: null,
            indeterminate: false,
            state: null,
        }),
        methods: {
            chk_change(value) {
                if (value) {
                    // true
                    this.state_true();
                } else {
                    // false
                    if (this.state == 1) {
                        this.state_null();
                    } else {
                        this.state_false();
                    }
                }
                this.$emit('input', this.state);
            },
            state_true() {
                this.chk = true;
                this.indeterminate = false;
                this.state = 1;
            },
            state_false() {
                this.chk = false;
                this.indeterminate = false;
                this.state = 0;
            },
            state_null() {
                this.chk = true;
                this.indeterminate = true;
                this.state = null;
            }
        },
        mounted() {
            if (this.value == 1) {
                this.state_true();
            } else if (this.value == 0) {
                this.state_false();
            } else {
                this.state_null();
            }
        },
    }
</script>
